import { onAuthStateChanged, signOut, multiFactor } from 'firebase/auth';

// Only the known service origin may receive a Firebase token, never an arbitrary return URL.
export function startMcpLogin(auth) {
    const params = new URLSearchParams(window.location.search);
    const nonce = params.get('mcp-login');
    const origin = params.get('mcp-origin');
    if (!nonce || !/^[A-Za-z0-9_-]{16,128}$/.test(nonce) || !window.opener) return;
    const allowed = origin === 'https://customer-services.zonatic.tech' ||
        (window.location.hostname === 'localhost' && /^https?:\/\/localhost:\d+$/.test(origin || ''));
    if (!allowed) return;

    const dialog = document.createElement('dialog');
    dialog.style.cssText = 'max-width:440px;padding:28px;border:1px solid #888;border-radius:16px;font:16px/1.5 system-ui';
    const title = document.createElement('h2');
    title.textContent = 'Connecta Zonatic';
    const description = document.createElement('p');
    const status = document.createElement('p');
    status.setAttribute('role', 'status');
    const continueButton = document.createElement('button');
    continueButton.textContent = 'Continua amb aquest compte';
    const switchButton = document.createElement('button');
    switchButton.textContent = 'Canvia de compte';
    for (const button of [continueButton, switchButton]) {
        button.style.cssText = 'font:inherit;padding:10px 14px;margin:6px;border-radius:6px;cursor:pointer';
    }
    dialog.append(title, description, status, continueButton, switchButton);
    document.body.append(dialog);
    onAuthStateChanged(auth, user => {
        if (user?.emailVerified && multiFactor(user).enrolledFactors.length > 0) {
            description.textContent = `Continua com a ${user.email}. A la finestra anterior podràs revisar i autoritzar els permisos o el canvi.`;
            if (!dialog.open) dialog.showModal();
        } else if (dialog.open) dialog.close();
    });
    continueButton.addEventListener('click', async () => {
        continueButton.disabled = true;
        try {
            const user = auth.currentUser;
            if (!user?.emailVerified || multiFactor(user).enrolledFactors.length === 0) throw new Error();
            const idToken = await user.getIdToken(true);
            window.opener.postMessage({ type: 'zonatic-mcp-login', nonce, idToken, email: user.email }, origin);
            window.close();
            status.textContent = 'Pots tornar a la finestra d’autorització.';
        } catch {
            status.textContent = 'No s’ha pogut confirmar la sessió. Torna-ho a provar.';
            continueButton.disabled = false;
        }
    });
    switchButton.addEventListener('click', async () => {
        try {
            await signOut(auth);
            dialog.close();
        } catch {
            status.textContent = 'No s’ha pogut tancar la sessió. Torna-ho a provar.';
        }
    });
}
